import React from 'react';

interface PaymentReportsReportProps {
  onBack?: () => void;
}

const PaymentReportsReport: React.FC<PaymentReportsReportProps> = ({ onBack }) => {
  return (
    <div style={{
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      padding: '1rem'
    }}>
      {/* Breadcrumb */}
      <div style={{
        fontSize: '0.875rem',
        color: '#d1d5db',
        marginBottom: '1rem'
      }}>
        <button
          onClick={onBack}
          style={{
            background: 'none',
            border: 'none',
            color: '#d1d5db',
            textDecoration: 'none',
            cursor: 'pointer',
            padding: 0,
            font: 'inherit'
          }}
        >
          Analytics
        </button>
        {' / '}
        <span style={{ color: '#111827' }}>Payment reports</span>
      </div>

      {/* Page Header */}
      <h1 style={{
        fontSize: '1.875rem',
        fontWeight: '700',
        color: '#111827',
        margin: '0 0 1.5rem 0'
      }}>
        Payment Reports
      </h1>

      {/* Coming Soon */}
      <div style={{
        padding: '48px',
        textAlign: 'center',
        backgroundColor: '#28527A',
        borderRadius: '8px'
      }}>
        <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>&#128202;</div>
        <h3 style={{ color: '#e5e7eb', marginBottom: '0.75rem', fontSize: '1.1rem' }}>Payment Reports</h3>
        <p style={{ color: '#d1d5db', fontSize: '0.95rem', marginBottom: '0.5rem' }}>
          This report will display real data once your practice is active.
        </p>
        <p style={{ color: '#9ca3af', fontSize: '0.85rem', maxWidth: '500px', margin: '0 auto' }}>
          As appointments are completed and billing is processed, your report data will populate automatically.
        </p>
      </div>
    </div>
  );
};

export default PaymentReportsReport;
